import EventEmitter from 'eventemitter3';

import { SessionEvents } from '../constants';
import { SessionEventCallback } from '../types';

type DeregisterCallback = () => void;

export class SessionEventChannel {
  private emitter: EventEmitter;

  constructor() {
    this.emitter = new EventEmitter();
  }

  registerOnTokenAdded = (callback: SessionEventCallback): DeregisterCallback => {
    this.emitter.on(SessionEvents.TOKEN_ADDED, callback);

    return (): void => {
      this.emitter.removeListener(SessionEvents.TOKEN_ADDED, callback);
    };
  };

  registerOnTokenRemoved = (callback: SessionEventCallback): DeregisterCallback => {
    this.emitter.on(SessionEvents.TOKEN_REMOVED, callback);

    return (): void => {
      this.emitter.removeListener(SessionEvents.TOKEN_REMOVED, callback);
    };
  };

  registerOnTokenChange = (callback: SessionEventCallback): DeregisterCallback => {
    this.emitter.on(SessionEvents.TOKEN_REMOVED, callback);
    this.emitter.on(SessionEvents.TOKEN_ADDED, callback);

    return (): void => {
      this.emitter.removeListener(SessionEvents.TOKEN_REMOVED, callback);
      this.emitter.removeListener(SessionEvents.TOKEN_ADDED, callback);
    };
  };

  registerOnSessionObjectsCleared = (callback: SessionEventCallback): DeregisterCallback => {
    this.emitter.on(SessionEvents.SESSION_OBJECTS_CLEARED, callback);

    return (): void => {
      this.emitter.removeListener(SessionEvents.SESSION_OBJECTS_CLEARED, callback);
    };
  };

  emitSessionObjectsCleared = (): void => {
    this.emitter.emit(SessionEvents.SESSION_OBJECTS_CLEARED);
  };

  emitTokenRemoved = (): void => {
    this.emitter.emit(SessionEvents.TOKEN_REMOVED);
  };

  emitTokenAdded = (): void => {
    this.emitter.emit(SessionEvents.TOKEN_ADDED);
  };
}
